import { EventBus } from "@/event-bus.js";

export default class vuetifyToast {
    static success(message, timeout = 4000) {
        EventBus.$emit("toast", "success", message, timeout);
    }
    static error(message, timeout = 4000) {
        EventBus.$emit("toast", "error", message, timeout);
    }
    static info(message, timeout = 4000) {
        EventBus.$emit("toast", "info", message, timeout);
    }
    static warning(message, timeout = 4000) {
      EventBus.$emit("toast", "warning", message, timeout);
    }
}
